var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0625 9.06094L9.99996 3.46306L15.9375 9.06102V16.2292C15.9375 16.6664 15.5831 17.0208 15.1458 17.0208H4.85417C4.41694 17.0208 4.0625 16.6664 4.0625 16.2292V9.06094ZM10 14.6458L9.54083 14.2187L9.53684 14.215C7.90822 12.706 6.83333 11.7101 6.83333 10.488C6.83333 9.49137 7.59967 8.70833 8.575 8.70833C9.126 8.70833 9.65483 8.97041 10 9.38461C10.3452 8.97041 10.874 8.70833 11.425 8.70833C12.4003 8.70833 13.1667 9.49137 13.1667 10.488C13.1667 11.7079 12.0955 12.7026 10.4717 14.2104L10.4592 14.222L10 14.6458Z",
    fill: "white",
    fillOpacity: 0.31
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8147 2.05499C10.3573 1.6237 9.64294 1.6237 9.18548 2.05499L1.14453 9.63608L2.23069 10.7881L10.0001 3.46304L17.7695 10.7881L18.8557 9.63608L10.8147 2.05499Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.541 14.2187L10.0002 14.6458L10.4593 14.222L10.4718 14.2103C12.0957 12.7026 13.1668 11.7079 13.1668 10.488C13.1668 9.49137 12.4005 8.70833 11.4252 8.70833C10.8742 8.70833 10.3453 8.97041 10.0002 9.38457C9.655 8.97041 9.12616 8.70833 8.57516 8.70833C7.59983 8.70833 6.8335 9.49137 6.8335 10.488C6.8335 11.7101 7.90838 12.706 9.537 14.215L9.541 14.2187Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1b71629116d62db8d6869bb7ef44083d.svg";
export { ForwardRef as ReactComponent };